export default function initFaq() {
    if (document.querySelector('.faq-categorie-page')) {
        new Faq(document.querySelector('.faq-categorie-page'));
    }
}

/**
 * @param {HTMLElement} $el HTML Element
 */
class Faq {
    constructor($el) {
        this.$el = $el;
        this.$btnToggleExpand = $el.querySelector('.js-btn-toggle-expand');
        this.questionsWrapper = $el.querySelector('.js-questions-wrapper');
        this.init();
    }
    /**
     * @return {void}
     */
    init() {
        this.$btnToggleExpand.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.questionsWrapper.classList.toggle('open');
        });
    }
}
